import { Component, OnInit, Input, inject } from '@angular/core';
import { SubItemCharts } from '../../models/subItemCharts-models';
import { SessionStorageService } from '../../services/session-storage.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sub-item-chart',
  templateUrl: './sub-item-chart.component.html',
  styleUrls: ['./sub-item-chart.component.scss'],
  imports: [MatIconModule, CommonModule],
})
export class SubItemChartComponent implements OnInit {
  private ss = inject(SessionStorageService);

  @Input() data: SubItemCharts;
  @Input() chartTitle: string;
  @Input() chartStyle: string;

  title;
  style;
  yellowNegative: boolean;

  ngOnInit() {
    if (this.data.data) {
      this.data.Data = [...this.data.data];
    }

    if (this.data.header) {
      this.data.Header = [...this.data.header];
    }

    this.title = this.chartTitle;
    this.style = this.chartStyle;

    this.yellowNegative =
      this.ss.get('globals')?.GlobalsGroup.UnitReasonTextSettings
        ?.TurnNegativeReasonTextYellow;
  }
}
